import IntroModalContent from 'pages/Registration/Intro/IntroModalContent';
import InternetBankingIcon from 'assets/icons/ico-ib.svg?react';
import { Typography } from 'components';
import s from './InternetBanking.module.scss';
import { useTranslation } from 'react-i18next';

import AirBankIcon from 'assets/psd2/AIRBANK.svg?react';
import CeskasBankIcon from 'assets/psd2/CSAS.svg?react';
import CreditasBankIcon from 'assets/psd2/CREDITAS.svg?react';
import CSOBBankIcon from 'assets/psd2/CSOB.svg?react';
import KBBankIcon from 'assets/psd2/KB.svg?react';
import MBankIcon from 'assets/psd2/MBANK.svg?react';
import MonetaBankIcon from 'assets/psd2/MONETA.svg?react';
import RaiffeisenBankIcon from 'assets/psd2/RAIFFEISEN.svg?react';

function InternetBankingModal() {
  const { t } = useTranslation();
  return (
    <IntroModalContent
      heading={t('intro:modal_internet_banking.heading')}
      iconComponent={<InternetBankingIcon />}
      points={[
        t('intro:modal_internet_banking.point_1'),
        t('intro:modal_internet_banking.point_2'),
        t('intro:modal_internet_banking.point_3'),
        t('intro:modal_internet_banking.point_4'),
      ]}
    >
      <Typography
        kind="h3"
        size="m"
        fontWeight={700}
        className={s['section-heading']}
        dataTest="internetBankingModal-banks"
      >
        {t('intro:modal_internet_banking.supported_banks')}
      </Typography>

      <div className={s.grid}>
        <div className={s.item}>
          <CeskasBankIcon
            className={s.icon}
            data-test="internetBankingModal-banks-ceskas"
          />
        </div>
        <div className={s.item}>
          <CreditasBankIcon
            className={s.icon}
            data-test="internetBankingModal-banks-creditas"
          />
        </div>
        <div className={s.item}>
          <MonetaBankIcon
            className={s.icon}
            data-test="internetBankingModal-banks-moneta"
          />
        </div>
        <div className={s.item}>
          <RaiffeisenBankIcon
            className={s.icon}
            data-test="internetBankingModal-banks-raiffeisen"
          />
        </div>
        <div className={s.item}>
          <AirBankIcon
            className={s.icon}
            data-test="internetBankingModal-banks-airbank"
          />
        </div>
        <div className={s.item}>
          <MBankIcon
            className={s.icon}
            data-test="internetBankingModal-banks-mbank"
          />
        </div>
        <div className={s.item}>
          <CSOBBankIcon
            className={s.icon}
            data-test="internetBankingModal-banks-csob"
          />
        </div>
        <div className={s.item}>
          <KBBankIcon
            className={s.icon}
            data-test="internetBankingModal-banks-kbbank"
          />
        </div>
      </div>
    </IntroModalContent>
  );
}

export default InternetBankingModal;
